/* "Type the name to confirm" has to accept what a keyboard can produce.
 *
 * A client named “Rock ‘N Block” — with a typographic left quote pasted from a
 * document — could not be deleted: the modal compared strings exactly, no key
 * on a keyboard makes U+2018, and the button never armed. The typed text is
 * still the safeguard; it just stops caring about characters that only differ
 * in typography. */

const QUOTES: Record<string, string> = {
  '‘': "'", '’': "'", '‚': "'", '‛': "'", '′': "'", '´': "'", '`': "'",
  '“': '"', '”': '"', '„': '"', '‟': '"', '″': '"',
  '–': '-', '—': '-', '−': '-',
  ' ': ' ',
};

export function normalizeName(s: string): string {
  return s
    .replace(/[‘’‚‛′´`“”„‟″–—− ]/g, (c) => QUOTES[c] ?? c)
    .normalize('NFKC')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

/** True when what was typed is the name, allowing only typographic differences. */
export function namesMatch(typed: string, name: string): boolean {
  const a = normalizeName(typed);
  return a.length > 0 && a === normalizeName(name);
}
